import cc26SplashLottie from "assets/campaigns/cc26/splash.lottie";
import { CampaignTheme } from "./types";
import { CDN_IMAGES_STATIC } from "utils/constants";

// Creator Carnival 2026: 7–23 Oct 2026 IST (activeTo is exclusive).
const CREATOR_CARNIVAL_2026: CampaignTheme = {
  id: "cc26",
  activeFrom: "2026-10-07T00:00:00+05:30",
  activeTo: "2026-10-24T00:00:00+05:30",
  slots: {
    homeHeader: {
      background: "#5F2984",
      appearance: "dark",
    },
    homeHero: {
      // 1080x822 art (360x274 at 3x) with the bottom left clear for the counter.
      imageUrl: `${CDN_IMAGES_STATIC}cc26/cc26_home_banner_counter.jpg`,
      aspectRatio: "360 / 274",
      placeholderColor: "#F9A11B",
      // Header purple at 70% opacity.
      summaryCardBackground: "rgba(95, 41, 132, 0.7)",
      counter: {
        statsCampaignId: "cc26",
        caption: "Wishlinks Shared this Carnival",
        iconName: "fa-solid fa-link",
        // 759x183 (253x61 at 3x): ticket, bunting texture and drop shadow.
        ticketImageUrl: `${CDN_IMAGES_STATIC}cc26/cc26_counter_ticket.png`,
        pillBackground: "#FFE7A0",
        numberColor: "#FC014F",
        captionColor: "#582C7F",
      },
    },
    splashIntro: {
      lottieSrc: cc26SplashLottie,
      // One 2s loop at least, then hold (looping) until the app has loaded.
      minDurationMs: 2000,
      maxDurationMs: 8000,
      // Matches the animation's own background so loading never flashes.
      background: "#FCB813",
    },
  },
};

export const CAMPAIGN_THEMES: CampaignTheme[] = [CREATOR_CARNIVAL_2026];
